// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3bQkx","inner":"Footer_inner__27yoi","nextIcon":"Footer_nextIcon__3rfK_","innerLeft":"Footer_innerLeft__iCdkS"};